// extracted by mini-css-extract-plugin
export default {"wrap":"jF-z","fullWidth":"kF-z","hideOnDesktop":"lF-z","content":"mF-z","hasOpenedNav":"nF-z","crumbsList":"oF-z","dropdownsWrap":"pF-z"};